export default __webpack_public_path__ + "static/media/ic-instruction-14.d805dc4a.svg";